import React from 'react';

import Layout from 'client/app/apps/disco-prototype/DefineLiquidSetPage/Layout';
import Page from 'client/app/apps/disco-prototype/DefineLiquidSetPage/Page';

export default () => (
  <Layout>
    <Page />
  </Layout>
);
